import * as at from './actionTypes';

export function setRentalPlanIndex(rentalPlanIndex) {
    return (dispatch) => {
        dispatch({ type: at.SET_RENTAL_PLAN_INDEX, rentalPlanIndex });
    };
}
